/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Pagination from 'react-js-pagination';
// import './Floors.css';
import Tabbar from '../../Components/Tabbar/Tabbar';
import Li from '../../Components/Li/Li';
// @ts-ignore
import AddNewLi from './../../Components/Li/AddNewLi';
import {  addNewAccount,  delAccount,  clearSuccess, getAccounts } from '../../Store/Actions/RestActions';
import SuccessModal from '../../Components/successModal';


class AccountsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activePage: 1,
		};
		this.handlePageChange = this.handlePageChange.bind(this);
	}

	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
	}
	componentDidMount() {
	 this.props.accountsFetch();
		
	}
	render() {
		const accountsWithPagination = this.props.accounts.length ? this.props.accounts.slice((this.state.activePage - 1) * 10, this.state.activePage * 10) : [];
		return (
			<div className="container">
				<Tabbar setActiveTab="accounts" />
				<div className="contentBox tabbed-content-box">
					<div className="">
						<AddNewLi mainDesc="Add New Account" RouteKey="accounts" />
						<Li
							onClick={this.props.scheduleFetch}
							showDelete={true}
							LiList={
								{
									linkKey: 'accounts',
									liClass: 'liListClass',
									items: accountsWithPagination,
									deleteClick: this.props.deleteClick,
								}
							}
						/>
						<div className="paginationWrapper">
							<Pagination
								hideDisabled
								prevPageText="prev"
								nextPageText="next"
								firstPageText="first"
								lastPageText="last"
								activePage={this.state.activePage}
								itemsCountPerPage={10}
								totalItemsCount={this.props.accounts.length}
								onChange={this.handlePageChange}
							/>
						</div>
					</div>
				</div>
				<SuccessModal success={this.props.success} successMsg="Account action completed successfully." onClose={this.props.clearSuccess}></SuccessModal>								
			</div>
		);
	}
}

const mapStateToProps = state => ({
	
	accounts: state.accounts.data,
	success: state.accounts.success
	
});

const mapDispatchtoProps = dispatch => ({
	accountsFetch: () => dispatch(getAccounts({})),
	addClick: data => dispatch(addNewAccount(data)),
	deleteClick: id => dispatch(delAccount('accounts', {}, id)),
	//activateClick: id => dispatch(activateAccount('accounts', {}, id)),
	clearSuccess: () => dispatch(clearSuccess('accounts'))			
});
export default connect(mapStateToProps, mapDispatchtoProps)(AccountsPage);





// WEBPACK FOOTER //
// ./src/Pages/Accounts/Accounts.js